var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin-layout"}},[_c('AdminLayoutHeader'),_c('AdminLayoutSidebar'),_c('AdminLayoutContent'),_c('AdminLayoutFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }